<button
  tuiIconButton
  type="button"
  appearance="secondary"
  [iconStart]="'@tui.copy'"
  [tuiHint]="'components.copyToClipboardButton.buttons.copyLink' | translate"
  [size]="size"
  (click)="copyLinkToClipboard()"
></button>
